import helpers from "../helpers";


export default {

    ...{
        async applyFilters ({ commit, state, dispatch }, query) {
            const nextOrBack = query.nextOrBack || false
            delete query.nextOrBack
            console.log('query: ', query)
            Object.keys(query).map(key => {
                if(state.filters[key] && key.indexOf('filter_') === 0) {
                    if(!query[key]) {
                        return;
                    }
                    const arr = [...[], ...state.filters[key].split(',')]

                    const index = arr.indexOf(query[key])
                    if(index !== -1) {
                        delete arr[index]
                        query[key] = arr.filter(i => i).join(',')
                    } else {
                        arr.push(query[key])
                        query[key] = arr.filter(i => i).join(',')
                    }
                }
            })

            commit('UPDATE_FILTERS', query)
            dispatch('loading')
            await helpers.renderProductList(query, state, nextOrBack)
            document.querySelector(".main-content")?.scrollIntoView()
            dispatch('loading', false)
        },
        loading ({ commit, state }, isLoading) {
            commit('LOADING', isLoading)
        },

        onImageLoadError ({ commit, state }, event) {
            commit('ON_IMAGE_LOAD_ERROR', event)
        },
    },

}
